module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/qAF1H1/tc-custom/9781680572902.jpg?1705346008608",
      "alt": "This image is the cover for the book Triploidy"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Triploidy\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("When their baby is born with a genetic defect caused by an extraterrestrial intelligence, new parents must fight to save their child—and humanity.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" A medical mystery . . . and a threat from beyond the stars."), _c('br'), _c('br'), _vm._v(" For Jon and Marianna Knox, the birth of their daughter Persephone marks the happiest day of their lives. Until they learn that Persey is suffering from a rare but fatal condition called “triploidy.”"), _c('br'), _c('br'), _vm._v(" Her doctors are baffled, and with good reason—because the source of the little girl’s genetic malfunction is not of this Earth. It lies out beyond the orbit of Saturn."), _c('br'), _c('br'), _vm._v(" And it’s coming for all of us."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Praise for Bill DeSmedt’s "), _c('i', [_vm._v("Singularity:")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “A swift, gripping novel with a goose-pimple mix of scary science and near-future action.” —Greg Bear, "), _c('i', [_vm._v("New York Times")]), _vm._v("–bestselling, Hugo & Nebula Award–winning author of "), _c('i', [_vm._v("The Unfinished Land")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “An action-packed thriller into perilous realms of black hole physics.” —David Brin, "), _c('i', [_vm._v("New York Times")]), _vm._v("–bestselling, Hugo & Nebula Award–winning author of "), _c('i', [_vm._v("Colony High")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Bill DeSmedt\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    WordFire Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0